import React from "react";
import PaymentCancelCard from "./PaymentCancelCard";
import DriverCard from "./DriverCard";
import OrderStatusOverview from "./OrderStatusOverview";
import PoiInfoCard from "./PoiInfoCard";
import { useReceiptCardInfo } from "./handler/useReceiptCardInfo";
import { ILeftCarProps } from "./types";
import { useTranslation } from "react-i18next";
import DownloadApp from "./DownloadApp";

const LeftCard: React.FC<ILeftCarProps> = ({
  orderStatus,
  data,
  className,
  onCancel,
  hidePaymentAndCancel = false,
}) => {
  const { t } = useTranslation("webReceipt");
  const {
    cardType,
    cardNumber,
    pickupTime,
    pickupDisplayName,
    pickupAddress,
    dropoffDisplayName,
    dropoffAddress,
    licensePlate,
    carModel,
    carMake,
    driverName,
    driverPhone,
    mainTitle,
    subTitle,
    timeInfo,
    total,
    carIcon,
    cancellationFee,
    status,
  } = useReceiptCardInfo(orderStatus, data);
  const showCancelBtn =
    !["cancelled", "completed"].includes(orderStatus) &&
    !["ON_GOING"].includes(status);

  const showDriverCard =
    ["ACCEPTED", "CHECK_IN"].includes(status) ||
    (["enroute", "intransit"].includes(orderStatus) &&
      data?.driver?.licensePlate);

  const showDriverInfoBanner = ["ACCEPTED", "CHECK_IN"].includes(status);

  const showDownloadBanner = orderStatus === "scheduled";
  const isArrived = status === "ARRIVED";
  return (
    <div
      className={`bg-nobel-50 rounded-lg flex flex-col w-full pb-6 
        md:border md:border-gray-200 ${className ?? ""}`}
    >
      <OrderStatusOverview
        status={orderStatus}
        mainTitle={mainTitle}
        subtitle={subTitle}
        timeInfo={timeInfo}
        showDriverInfoBanner={showDriverInfoBanner}
        isArrived={isArrived}
      />
      {showDriverCard && (
        <div className="mt-1">
          <DriverCard
            licensePlate={licensePlate}
            carModel={carModel}
            carMake={carMake}
            driverName={driverName}
            driverPhone={driverPhone}
            carImageUrl={carIcon}
            status={orderStatus}
          />
        </div>
      )}
      <div className="mt-1">
        <PoiInfoCard
          time={pickupTime}
          pickupPoi={pickupDisplayName}
          pickupAddress={pickupAddress}
          dropoffPoi={dropoffDisplayName}
          dropoffAddress={dropoffAddress}
        />
      </div>
      {showDownloadBanner && (
        <div className="mt-1 block md:hidden">
          <DownloadApp />
        </div>
      )}
      {!hidePaymentAndCancel && (
        <div className="mt-1">
          <PaymentCancelCard
            cancellationFee={cancellationFee}
            cardType={cardType}
            maskedPin={cardNumber}
            total={total}
            status={"active"}
            {...(showCancelBtn
              ? {
                  onCancel,
                  cancelText: t("commonCancelButton"),
                }
              : {})}
            txId={data?.id}
          />
        </div>
      )}
    </div>
  );
};

export default LeftCard;
